import PageHeader from "../core/App/PageHeader";
import PagePanel from "../core/App/PagePanel";
import { ReleaseNotes } from 'legoland-sdk/dist/experimental';
import { Heading } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ReleaseNotesPage = () => /*#__PURE__*/_jsxs("div", {
  "data-sentry-component": "ReleaseNotesPage",
  "data-sentry-source-file": "ReleaseNotesPage.tsx",
  children: [/*#__PURE__*/_jsx(PageHeader, {
    transparent: true,
    "data-sentry-element": "PageHeader",
    "data-sentry-source-file": "ReleaseNotesPage.tsx",
    "data-sentry-element": "PageHeader",
    children: /*#__PURE__*/_jsx(Heading, {
      level: 1,
      $mb: "0",
      "data-sentry-element": "Heading",
      "data-sentry-source-file": "ReleaseNotesPage.tsx",
      "data-sentry-element": "Heading",
      children: "Release notes"
    })
  }), /*#__PURE__*/_jsx(PagePanel, {
    "data-sentry-element": "PagePanel",
    "data-sentry-source-file": "ReleaseNotesPage.tsx",
    "data-sentry-element": "PagePanel",
    children: /*#__PURE__*/_jsx(ReleaseNotes, {
      markRead: true,
      "data-sentry-element": "ReleaseNotes",
      "data-sentry-source-file": "ReleaseNotesPage.tsx",
      "data-sentry-element": "ReleaseNotes"
    })
  })]
});